export default __webpack_public_path__ + "static/media/CRAZY_SHOP_Logo.69a62089.png";